import { render, staticRenderFns } from "./browse-latest-mixes.vue?vue&type=template&id=18fc2c8b&"
import script from "./browse-latest-mixes.vue?vue&type=script&lang=js&"
export * from "./browse-latest-mixes.vue?vue&type=script&lang=js&"
import style0 from "./browse-latest-mixes.vue?vue&type=style&index=0&id=18fc2c8b&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports